import axiosClient from "../axios-client";
import {toastMessage} from "../toaster/toaster";

export const getFollowUpList = async () => {
    return axiosClient
        .get("/follow-up/list")
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Follow up order records not found", "error");
            return 'error';
        });
};


export const getFollowUpDetailById = async (id) => {
    return axiosClient
        .get(`/follow-up/detail/${id}`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Follow up order detail not found", "error");
            return error;
        });
};

export const addNewFollowUpActivity = async (id, data) => {
    return axiosClient
        .put(`/follow-up/update/${id}`, data)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Follow up order detail not found", "error");
            return error;
        });
};
